import { StringUtil } from './string.util';

export class NumberUtil {
  public static roundOfDecimal(value: string | number, digit: number): number {
    if (isNaN(+value)) {
      return 0;
    }

    const numValue = parseFloat(value.toString());
    // Gets the number rounded off as configured.
    const roundedOffNumber = numValue.toFixed(digit);
    // Removes the trailing zeroes if any.
    const parsedRoundedOffNumber = parseFloat(roundedOffNumber);

    // Check if the number has any digit after the decimal point,
    // if there are no digits after the decimal point at all
    // Or if the digits after the decimal point are all zeroes,
    // returns the number before the decimal point.
    if (parsedRoundedOffNumber % 1 === 0) {
      return +roundedOffNumber?.split('.')[0];
    }

    return parsedRoundedOffNumber;
  }

  // check user input decimal number
  public static noFloatNumber(event: any, keyCode: number): boolean {
    if (keyCode === 46) {
      return true;
    }
    return false;
  }

  // check user input '+' and '-' character
  public static noPlusandDoubleMinusCharacter(event: any, keyCode: number): boolean {
    if (event.target.value.length == 0 && keyCode === 45) {
      event.target.value = '';
    }
    if (event.target.value.length > 0 && keyCode === 45) {
      event.preventDefault();
    }

    if (keyCode === 43) {
      return true;
    }
    return false;
  }

  // check user input '+' and '-' character
  public static noPlusandMinusCharacter(event: any, keyCode: number): boolean {
    if (keyCode === 43 || keyCode === 45) {
      return true;
    }
    return false;
  }

  // check user input with decimal configuration
  public static limitDecimalConfiguration(event: any, decimalDigit: number): boolean {
    const value = event.target.value.toString();
    const decimal = value.split('.')[1];
    if (!StringUtil.isEmpty(decimal) && decimal.length === decimalDigit) {
      event.preventDefault();
      return true;
    }
    return false;
  }

  // check user input 'e' or 'E' number
  public static noShortenNumber(event: any, keyCode: number): boolean {
    if (keyCode === 101 || keyCode === 69) {
      return true;
    }
    return false;
  }

  // slice number by min and max value
  public static sliceNumberByMinAnMax(event: any, minValue: number, maxValue: number) {
    let textOnPaste = event.clipboardData.getData('Text');
    if (!isNaN(textOnPaste) && !textOnPaste.includes('+')) {
      if (parseInt(textOnPaste, 10) < minValue) {
        textOnPaste = textOnPaste.slice(0, minValue.toString().length);
      }
      if (parseInt(textOnPaste, 10) > maxValue) {
        textOnPaste = textOnPaste.slice(0, maxValue.toString().length);
      }
      return parseInt(textOnPaste, 10);
    }
    return null;
  }

  // handle onpaste accept positive number
  public static acceptPositiveNumber(event: any) {
    let textOnPaste = event.clipboardData.getData('Text');
    if (
      isNaN(textOnPaste) ||
      textOnPaste.includes('+') ||
      textOnPaste.includes('-') ||
      textOnPaste.includes('.')
    ) {
      return null;
    }
    return parseInt(textOnPaste, 10);
  }

  // slice number by tofixed decimal configuration
  public static toFixedNumberByDecimalConfiguration(event: any, decimalDigit: number) {
    let textOnPaste = event.clipboardData.getData('Text');
    const decimal = textOnPaste.split('.')[1];

    if (
      isNaN(textOnPaste) ||
      textOnPaste.includes('+') ||
      textOnPaste.includes('-') ||
      StringUtil.isEmpty(decimal)
    ) {
      return null;
    }

    if (!StringUtil.isEmpty(decimal) && decimal.length <= decimalDigit) {
      return parseFloat(textOnPaste);
    }

    return parseFloat(textOnPaste).toFixed(decimalDigit);
  }
}
